import { render, staticRenderFns } from "./ReligarAssociadoDesliugado.vue?vue&type=template&id=1dc110b0"
import script from "./ReligarAssociadoDesliugado.vue?vue&type=script&lang=ts"
export * from "./ReligarAssociadoDesliugado.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports